module.exports = __webpack_public_path__ + "static/devtop-f8c525d7f5a87b2d7536fbfa9ec1f6c3.jpg";